// extracted by mini-css-extract-plugin
module.exports = {"seat-fra":"ToolLeftSearchList_seat-fra__1NfRu"};